<template>
  <div class="message-bar" v-bind:class="{messageHidden: hideMessage, error: isError}">
    {{message}}
  </div>
</template>

<script>
export default {
  name: 'MessageBar',
  data () {
    return {
      hideMessage: true
    }
  },

  props: ['message', 'isError'],

  watch: {
    message: function (newVal, oldVal) {
      if (this.message !== '') {
        this.hideMessage = false

        setTimeout(() => {
          this.hideMessage = true
          this.$parent.setCurrentMessage('', false)
        }, 6000)
      }
    }
  }
}
</script>

<style scoped>
  .error {
    background: red !important;
  }

  .messageHidden {
    top: -75px !important;
  }

  .message-bar {
    background: green;
    color: white;
    font-size: 1.25em;
    line-height: 3em;
    position: fixed;
    text-align: center;
    top: 0;
    transition: all 1s ease-in-out;
    width: 100%;
    z-index: 1002 !important;
  }
</style>
